import React from 'react';
import { useParams } from 'react-router-dom';
import { useEventResult } from './hooks/useSwampData';
import { BannerHeader } from './components/BannerHeader';
import { EventResultsView } from './components/EventResultsView';
import { BACKGROUND_PATTERN_SRC } from './assets';
import './styles/SwampTavern.css';

export function EventResultPage() {
   const { eventId } = useParams<{ eventId: string }>();
   const { result, loading, error } = useEventResult(eventId);

   return (
      <div
         className="swamp-window"
         style={{ backgroundImage: `url(${BACKGROUND_PATTERN_SRC})` }}
      >
         <BannerHeader title={result?.title ?? 'Event'} backTo="/swamp" />

         <main className="swamp-window__body">
            {loading && <p className="swamp-status">Loading event results...</p>}
            {error && <p className="swamp-status swamp-status--error">{error}</p>}
            {result && <EventResultsView result={result} />}
         </main>
      </div>
   );
}
